import React from 'react';
import {
    styled,
    TextField,
} from "@mui/material";
import {format} from "date-fns";


const SpanEditorRaw = styled('div',{name:'MuiOutlinedInput-input'})({});
const SpanEditorRaw2 = styled('div',{name:'MuiOutlinedInput',slot:'root'})({});


function SpanEditor(props) {
    return <SpanEditorRaw className={props.className}>{props.value}</SpanEditorRaw>;
}

export function FixedField(props) {
    //theme.palette.text.primary
    return (<TextField
        InputProps={{readOnly: true}}
        sx={{
            backgroundColor:(theme)=>theme.palette.background.default,
            '& .MuiFilledInput-root':{backgroundColor:(theme)=>theme.palette.background.default}
        }}
        {...props} InputLabelProps={{ shrink: true }}/>);
    //const myClass = getFilledInputUtilityClass('input')+' '+getInputBaseUtilityClass('input');
    //const myClass = ;
/*    return (<FormControl className={(props.className??''+outerClass)} sx={(theme)=>({marginTop:theme.spacing(1),marginBottom:theme.spacing(0.5), borderBottom:"1px solid "+theme.palette.divider
    })}>
        <InputLabel shrink={!!props.value} variant="filled">{props.label}</InputLabel>
        <div className="MuiFilledInput-root MuiFilledInput-underline MuiInputBase-root MuiInputBase-colorPrimary MuiInputBase-formControl MuiInputBase-sizeSmall">
            <MyField/>
        <span className={myClass} style={{height:'100%',alignItems:'flex-end',paddingBottom:0}}>{props.value??''}</span>
        </div>
    </FormControl>);*/

}

